import {
  PremiumTrialsResponse,
  RecurringTrialsResponse
} from "@seneca/trials-service-client/dist/types";

export function getRemainingDailyFreeExamQuestions(
  trials: RecurringTrialsResponse | null | undefined
) {
  return trials?.dailyFreeExamQuestions.remaining;
}

export function getHasTriedBeforeExamQuestions(
  trials: RecurringTrialsResponse | null | undefined
) {
  return !!trials?.dailyFreeExamQuestions.hasTriedBefore;
}

export function getRemainingPremiumTrialExamQuestions(
  trials: PremiumTrialsResponse | null | undefined
) {
  return trials?.trials.INVITE_PARENTS_EXAM_QUESTIONS.remaining;
}

export function getUserRedeemedPremiumTrialExamQuestions(
  trials: PremiumTrialsResponse | null | undefined
) {
  return !!trials?.trials.INVITE_PARENTS_EXAM_QUESTIONS;
}
